module.exports = __webpack_public_path__ + "static/media/202-Abwarten_ID_1.d9c5ee9f.mp3";